const state={
    computed:0          //已完成课程数
}
const getters={};
const actions={};
const mutations={
    setComputed(state,v){
        state.computed = v;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
